module.exports = __webpack_public_path__ + "img/selected7-min.f6937cc8.png";